import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../_atomic/Spinner/Spinner';
import Overlay from '../../_atomic/Overlay/Overlay';
import './LoadingOverlay.scss';

const propTypes = {
  visible: PropTypes.bool.isRequired,
};

const LoadingOverlay = ({ visible }) => (
  <div>
    <Overlay visible={visible} className="loading-overlay">
      <div className="loading-overlay-text">
        <span>LOADING</span>
      </div>
      <Spinner size="100px" />
    </Overlay>
  </div>
);

LoadingOverlay.propTypes = propTypes;

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/_molecules/LoadingOverlay/LoadingOverlay.js